import React, { useState, useRef, useEffect, useCallback } from 'react';
// import { useTranslation } from "react-i18next";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import "../../../../../styles/_common.scss";
// import "./index.scss";

import NoDataFound from "../../../../../components/ui/NoDataFound";
import SkeletonLoader from "../../../../../components/ui/SkeletonLoader";
import Pagination from "../../../../../components/ui/Pagination";
import RadioButton from "../../../../../components/ui/RadioButton";
import Button from "../../../../../components/ui/Button";
import ProfileAvatar from "../../../../../components/ui/ProfileAvatar";
import DropDown from "../../../../../components/ui/DropDown";
import CustomTooltip from "../../../../../components/ui/Tooltip";

import { formatNumber, getTechnologiesImageUrl, getWebserverImageUrl } from "../../../../../utils/util";
import { searchIcon, filterIcon, cerInfoIcon } from "../../../../../utils/icons";

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

import apiEndpoints from "../../../../../apiEndpoints";

import { useSelector, useDispatch } from 'react-redux';
import { getThirdPartyRiskStats, resetThirdPartyRiskStats, getSubDoaminList, resetSubdomainList } from "../../../../../store/actions/thirdPartyRiskAction";

const newFindingsOption = [    
    {
        label: "Yes",
        value: "yes"
    },
    {
        label: "No",
        value: "no"
    },
    {
        label: "All",
        value: "all"
    }
]

const httpStatusOption = [    
    {
        label: "Active",
        value: "active"
    },
    {
        label: "Inactive",
        value: "inactive"
    },
    {
        label: "All",
        value: "all"
    }
]

const SecurityOverviewSubDomains = () => {

    const subDomainStatsResponse = useSelector((state) => state.thirdPartyRisk?.thirdPartyRiskStats);
    const subDomainListResponse = useSelector((state) => state.thirdPartyRisk?.subDomainList);

    const prevDomainIdRef = useRef(null);
    const prevScanIdRef = useRef(null);
    const filterWrapperRef = useRef(null);

    const dispatch = useDispatch();

    const { domainId, scanId, organizationId } = useScanInfoContext();

    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);

    const [searchValue, setSearchValue] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [isSearchFocused, setIsSearchFocused] = useState(false);

    const [scanNotFound, setScanNotFound] = useState(false);
    const [subDomainStats, setSubDomainStats] = useState("");
    const [statsLoading, setStatsLoading] = useState(false);
    const [showViewAllModal, setShowViewAllModal] = useState(false);
    const [selectedViewAll, setSelectedViewAll] = useState("");
    const [showTechnologyListModal, setShowTechnologyListModal] = useState(false);
    const [showIpAddressListModal, setShowIpAddressListModal] = useState(false);
    const [ipAddressList, setIpAddressList] = useState(null)

    const [isLoading, setIsLoading] = useState(false)
    const [subDomainList, setSubDomainList] = useState(null)
    const [seletectedtechnologiesList, setSeletectedtechnologiesList] = useState(null)

    const [subDomainTypeListOption, setSubDomainTypeListOption] = useState([]);
    const [webserverTypeOption, setWebserverTypeoption] = useState([]);

    //filter value
    const [showFilter, setShowFilter] = useState(false);
    const [newFindingsType, setNewFindingsType] = useState("");
    const [selectedHttpStatus, setSelectedHttpStatus] = useState("");
    const [selectedHttpsStatus, setSelectedHttpsStatus] = useState("");
    const [selectedSubdomainType, setSelectedSubdomainType] = useState("");
    const [selectedWebserverType, setSelectedWebserverType] = useState("");

    //selected filter value
    const [selectedFilterValue, setSelectedFilterValue] = useState({});

    const getProfileImage = (data, type) => {
        if(type === "profile") {
            const cleanName = data.name.replace(/\//g, '');
            return getTechnologiesImageUrl({ ...data, name: cleanName });
        } else {
            const obj  = {
                name : data.replace(/\//g, '')
            }
            return getTechnologiesImageUrl(obj);
        }
        
    }

    // const getSSLExpiredStatus = (data) => {        
    //     return data.ssl_certificates.some((data)=>data?.expired === true)
    // }

    // const getSSLExpiredPort = (data) => {
    //     let portList = data?.ssl_certificates.map((data)=>{
    //         if(!data?.expired) {
    //             return data?.port
    //         }
    //         return null
    //     })
    //     return portList.filter((data)=> data !== null)
    // }

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter" && isSearchFocused) {
            onSearch()
        }
    }

    const onSearch = () => {
        setCurrentPage(1)
        setSearchQuery(searchValue)
    }

    const applyFilter = () => {
        setCurrentPage(1);        
        setShowFilter(false);
        let obj = {
            findings: newFindingsType,
            httpStatus: selectedHttpStatus,
            httpsStatus: selectedHttpsStatus,
            subdomainType: selectedSubdomainType,
            webserverType: selectedWebserverType
        }
        setSelectedFilterValue(obj)
    }

    const isAnyFilterActive = Object.values(selectedFilterValue).some(value => Boolean(value));

    const resetFilterValue = () => {
        setCurrentPage(1);
        setSelectedFilterValue({})
        setNewFindingsType("")
        setSelectedHttpStatus("")
        setSelectedSubdomainType("")
        setSelectedWebserverType("")
    }

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const fetchSubDomainStats = useCallback(()=>{
        setStatsLoading(true)
        const baseUrl = `${apiEndpoints.scanInfo.thirdPartyRisk.securityOverview.subdomain.subDomainStats()}`
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const url = `${baseUrl}${params}`
        dispatch(getThirdPartyRiskStats(url))
    },[dispatch, domainId, scanId, organizationId])

    const fetchSubdomainList = useCallback(()=>{
        setIsLoading(true)
        const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}`;
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const queryParams = searchQuery ? `&query=${searchQuery}` : "";
        const newFindings = selectedFilterValue.findings && selectedFilterValue.findings !== "all" ? `&new_record=${selectedFilterValue.findings === "yes" ? true : false}` : "";
        const httpStatus = selectedFilterValue.httpStatus && selectedFilterValue.httpStatus !== "all" ? `&http_status=${selectedFilterValue.httpStatus}` : "" ;
        const httpsStatus = selectedFilterValue.httpsStatus && selectedFilterValue.httpsStatus !== "all" ? `&https_status=${selectedFilterValue.httpsStatus}` : "" ;
        const subdomainType = selectedFilterValue.subdomainType ? `&subdomain_type=${selectedFilterValue.subdomainType}` : ""
        const webserverType = selectedFilterValue.webserverType ? `&webserver_type=${selectedFilterValue.webserverType}` : ""
        const url = `${baseUrl}${params}${queryParams}${newFindings}${httpStatus}${httpsStatus}${subdomainType}${webserverType}`
        dispatch(getSubDoaminList(url))
    },[domainId, organizationId, scanId, currentPage, currentPageSize, searchQuery, selectedFilterValue, dispatch])

    useEffect(()=>{
        fetchSubdomainList()
    },[currentPage, fetchSubdomainList])

    useEffect(()=>{
        if(domainId !== prevDomainIdRef.current || scanId !== prevScanIdRef.current) {
            fetchSubDomainStats()
            setCurrentPage(1);
            prevDomainIdRef.current = domainId;
            prevScanIdRef.current = scanId;
        }
    },[domainId, scanId, fetchSubDomainStats])

    useEffect(()=>{
        if(subDomainStatsResponse !== null) {
            setStatsLoading(false)            
            setSubDomainStats(subDomainStatsResponse)
            if(subDomainStatsResponse?.stats?.subdomain_type?.records && Object.entries(subDomainStatsResponse?.stats?.subdomain_type?.records).length > 0) {
                let list = Object.entries(subDomainStatsResponse?.stats?.subdomain_type?.records).map(([key]) => {
                    return {
                        label: key,
                        value: key
                    }
                })
                setSubDomainTypeListOption(list)
            } else {
                setSubDomainTypeListOption([])
            }

            if(subDomainStatsResponse?.stats?.webserver_type?.records && Object.entries(subDomainStatsResponse?.stats?.webserver_type?.records).length > 0) {
                let list = Object.entries(subDomainStatsResponse?.stats?.webserver_type?.records).map(([key]) => {
                    return {
                        label: key,
                        value: key
                    }
                })
                setWebserverTypeoption(list)
            } else {
                setWebserverTypeoption([])
            }
            dispatch(resetThirdPartyRiskStats())
        }
    },[subDomainStatsResponse, dispatch])

    useEffect(()=>{
        if(subDomainListResponse != null) {
            setSubDomainList(subDomainListResponse)

            if(subDomainListResponse?.status === "failed") {
                setScanNotFound(true)
            } else {
                setScanNotFound(false)
            }
            dispatch(resetSubdomainList())
            setIsLoading(false)
        }
    },[subDomainListResponse, dispatch])

    useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (filterWrapperRef.current && !filterWrapperRef.current.contains(event.target)) {
                if(showFilter){
                    setShowFilter(false)
                }
            }
        }
    },[showFilter])


    return (
        <>
            <div className="scan-info-main-content">
                <div className="bg-white-with-shadow p-4">
                    <Row>                        
                        <Col lg={4}>
                            <div className="discover-doamin-container rounded p-3 h-100">
                                {
                                    statsLoading ?
                                    <SkeletonLoader type={"line"} count={2} currentPage={"subdomain"} />
                                    :
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">Subdomains</p>
                                        </div>
                                        <div className="d-flex gap-3">
                                            <div className="total-score-container rounded">
                                                <div className="users-totol-count d-flex">
                                                    <p className="total-score-count">{formatNumber(subDomainStats?.stats?.record_type?.total)}</p>
                                                    <div className="score-count mx-3">
                                                        <span className="new-record d-inline-block mx-1"></span>
                                                        <span className="existing-record d-inline-block"></span>
                                                        <p>Total Records</p>
                                                    </div>
                                                </div>
                                                <div className="new-exist-count d-flex gap-5 mt-3">
                                                    <p className="new-record"><span className="d-inline-block">{formatNumber(subDomainStats?.stats?.record_type?.new_record)}</span> New</p>
                                                    <p className="existing-record"><span className="d-inline-block">{formatNumber(subDomainStats?.stats?.record_type?.existing_record)}</span> Existing</p>
                                                </div>
                                            </div>
                                        </div>
                                    </motion.div>
                                }
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className="sub-domain-type-container rounded p-3 h-100">
                                {
                                    statsLoading ?
                                    <SkeletonLoader type={"line"} count={2} currentPage={"subdomain"} />
                                    :
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">Subdomain Type</p>
                                            {subDomainStats !== "" && subDomainStats?.stats?.subdomain_type?.records && Object.entries(subDomainStats?.stats?.subdomain_type?.records).length > 4 && <p className="view-all" onClick={()=>{
                                                setSelectedViewAll("Subdomain Type")
                                                setShowViewAllModal(true)
                                            }}>View all</p>}
                                        </div>
                                        <div className="total-records-container">
                                            <p className="content">{formatNumber(subDomainStats?.stats?.subdomain_type?.total)} <span>Total Records</span></p>
                                        </div>
                                        <Row className="mt-3">
                                            {
                                                subDomainStats !== "" && subDomainStats?.stats?.subdomain_type?.records && Object.entries(subDomainStats?.stats?.subdomain_type?.records).length > 0 &&
                                                Object.entries(subDomainStats?.stats?.subdomain_type?.records).map(([key, value], index) => {
                                                    if(index <= 3) {
                                                        return (
                                                            <Col lg={6} key={`subdomainType-${index}`}>
                                                                <p className="count-type sensitive-expo-count mt-2">
                                                                {formatNumber(value)} <span>{key}</span>
                                                                </p>
                                                            </Col>
                                                        )
                                                    }
                                                    return null;
                                                })
                                            }
                                        </Row>
                                    </motion.div>
                                }
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className="sub-domain-type-container web-server-type-container rounded p-3 h-100">
                                {
                                    statsLoading ?
                                    <SkeletonLoader type={"line"} count={2} currentPage={"subdomain"} />
                                    :
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">Webserver Type</p>
                                            {subDomainStats !== "" && subDomainStats?.stats?.webserver_type?.records && Object.entries(subDomainStats?.stats?.webserver_type?.records).length > 4 && <p className="view-all" onClick={()=>{
                                                setSelectedViewAll("Webserver Type")
                                                setShowViewAllModal(true)
                                            }}>View all</p>}
                                        </div>
                                        <div className="total-records-container">
                                            <p className="content">{formatNumber(subDomainStats?.stats?.webserver_type?.total)} <span>Total Records</span></p>
                                        </div>
                                        <div className="sub-domain-content">
                                            <Row className="mt-3">
                                                {
                                                    subDomainStats !== "" && subDomainStats?.stats?.webserver_type?.records && Object.entries(subDomainStats?.stats?.webserver_type?.records).length > 0 &&
                                                    Object.entries(subDomainStats?.stats?.webserver_type?.records).map(([key, value], index) => {
                                                        if(index <= 3) {
                                                            return (
                                                                <Col lg={6} key={`webserve-${index}`}>
                                                                    <div className="d-flex align-items-center gap-3 mt-2">
                                                                        <p className="count-type">{formatNumber(value)}</p>
                                                                        <ProfileAvatar type="domain" name={key} imageUrl={getWebserverImageUrl(key)} />
                                                                    </div>
                                                                </Col>
                                                            )
                                                        }
                                                        return null
                                                    })
                                                }
                                            </Row>
                                        </div>
                                    </motion.div>
                                }                                
                            </div>
                        </Col>
                        {/* <Col lg={4}>
                            <div className="sub-domain-type-container rounded p-3 h-100">
                                {
                                    statsLoading ?
                                    <SkeletonLoader type={"line"} count={2} currentPage={"subdomain"} />
                                    :
                                    <>
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">SSL Expiry (Days)</p>
                                            {subDomainStats !== "" && subDomainStats?.subdomain_type?.records && Object.entries(subDomainStats?.subdomain_type?.records).length > 4 && <p className="view-all" onClick={()=>{
                                                setSelectedViewAll("Subdomain Type")
                                                setShowViewAllModal(true)
                                            }}>View all</p>}
                                        </div>
                                        <div className="total-records-container">
                                            <p className="content">29 <span>Total Ports</span></p>
                                        </div>
                                        <Row className="mt-3">
                                            {
                                                subDomainStats !== "" && subDomainStats?.subdomain_type?.records && Object.entries(subDomainStats?.subdomain_type?.records).length > 0 &&
                                                Object.entries(subDomainStats?.subdomain_type?.records).map(([key, value], index) => {
                                                    if(index <= 3) {
                                                        return (
                                                            <Col lg={6} key={`subdomainType-${index}`}>
                                                                <p className="count-type sensitive-expo-count mt-2">
                                                                {formatNumber(value)} <span>{key}</span>
                                                                </p>
                                                            </Col>
                                                        )
                                                    }
                                                    return null;
                                                })
                                            }
                                            <Col lg={6}>
                                                <p className="count-type sensitive-expo-count mt-2">
                                                05 <span>Expired</span>
                                                </p>
                                            </Col>
                                            <Col lg={6}>
                                                <p className="count-type sensitive-expo-count mt-2">
                                                02 <span>&gt;30 Days</span>
                                                </p>
                                            </Col>
                                            <Col lg={6}>
                                                <p className="count-type sensitive-expo-count mt-2">
                                                04 <span>&gt;60 Days</span>
                                                </p>
                                            </Col>
                                            <Col lg={6}>
                                                <p className="count-type sensitive-expo-count mt-2">
                                                07 <span>&gt;90 Days</span>
                                                </p>
                                            </Col>
                                        </Row>
                                    </>
                                }
                            </div>
                        </Col> */}
                    </Row>
                </div>
                <div className="domain-similarities-container git-leaks-main-content bg-white-with-shadow p-3 mt-3">
                    <div className="search-header-container d-flex align-items-center gap-3">
                        <div className="d-flex gap-3">
                            <div className="search-container position-relative" onKeyDown={handleSearchKeyDown}>
                                <span className="position-absolute">{searchIcon()}</span>
                                <input type="text" 
                                    placeholder="Search"
                                    value={searchValue} 
                                    onChange={(e)=>{
                                        setSearchValue(e.target.value)
                                    }}
                                    onFocus={() => setIsSearchFocused(true)}
                                    onBlur={() => setIsSearchFocused(false)}
                                />
                            </div>
                            <button className="search-btn" onClick={onSearch}>Search</button>
                        </div>
                        <div className="position-relative">                                        
                            <span className="filter-icon" onClick={()=>{setShowFilter(true)}}>{filterIcon()}</span>
                            {isAnyFilterActive && (<span className="reset-filter-link" onClick={resetFilterValue}>Reset Filter</span>)}
                            {showFilter && <div className="filters-container position-absolute p-3 rounded" ref={filterWrapperRef}>
                            <h6>New Findings</h6>
                            <div className="filter-user-status d-flex mb-4 gap-4">
                                {
                                    newFindingsOption.map((data,index)=>{
                                        return (
                                            <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setNewFindingsType(value)}} key={`new-${index}`} isChecked={data.value === newFindingsType} />
                                        )
                                    })
                                }
                            </div>
                            <h6>HTTP Status</h6>
                            <div className="filter-user-status d-flex mb-4 gap-4">
                                {
                                    httpStatusOption.map((data,index)=>{
                                        return (
                                            <RadioButton radioId={`http-${data.label}-${index}`} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setSelectedHttpStatus(value)}} key={`http1-${index}`} isChecked={data.value === selectedHttpStatus} />
                                        )
                                    })
                                }
                            </div>
                            <h6>HTTPS Status</h6>
                            <div className="filter-user-status d-flex mb-4 gap-4">
                                {
                                    httpStatusOption.map((data,index)=>{
                                        return (
                                            <RadioButton radioId={`https-${index}`} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setSelectedHttpsStatus(value)}} key={`http1-${index}`} isChecked={data.value === selectedHttpsStatus} />
                                        )
                                    })
                                }
                            </div>
                            <h6>Subdomain Type</h6>
                            <DropDown 
                                placeHolder={"Subdomain Type"}
                                options={subDomainTypeListOption}
                                isMulti={false}
                                isSearchable={false}
                                onChange={(data)=>{setSelectedSubdomainType(data.value)}}
                                defaultSelectedValue={selectedSubdomainType}
                            />
                            <h6 className="mt-4">Webserver Type</h6>
                            <DropDown 
                                placeHolder={"Webserver Type"}
                                options={webserverTypeOption}
                                isMulti={false}
                                isSearchable={false}
                                onChange={(data)=>{setSelectedWebserverType(data.value)}}
                                defaultSelectedValue={selectedWebserverType}
                            />
                            <div className="filter-apply-btn mt-3">
                                <Button buttonText={"Apply"}  buttonType={"primary"} disableButton={newFindingsType === "" && selectedHttpStatus === "" && selectedHttpsStatus === "" && selectedSubdomainType === "" && selectedWebserverType === ""} buttonClicked={()=>{applyFilter()}}/>
                            </div>
                            </div>}
                        </div>
                    </div>
                    <div className="table-container js-secrets-table mt-4">
                        {
                            isLoading ?
                            <SkeletonLoader type={"line"} count={5} currentPage={"subDomain"} />
                            :
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Assest</th>
                                        <th>Type</th>
                                        <th>IP Addresses</th>
                                        <th>Technologies</th>
                                        {/* <th>SSL Certificate</th> */}
                                        <th>Subdomain Takeover Risk</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        subDomainList?.results?.length > 0 &&
                                        subDomainList?.results?.map((data, index)=>{
                                            return (
                                                <motion.tr
                                                    key={index}
                                                    initial={{ opacity: 0, y: 20 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ duration: 0.4, delay: index * 0.1 }}
                                                >
                                                    <td>
                                                        <p className="dns-record-subdomain">{data?.subdomain} {data?.new_record && <span className="d-inline-block new-data mr-2">New</span>}</p>
                                                        <span className="dns-record-domain">{data?.domain}</span>
                                                        <div className="http-status">
                                                            {!data?.http_status?.http && <span className="status inactive">HTTP Inactive</span>}
                                                            {data?.http_status?.http && <span className="status active">HTTP Active</span>}
                                                            {!data?.http_status?.https && <span className="status inactive">HTTPS Inactive</span>}
                                                            {data?.http_status?.https && <span className="status active">HTTPS Active</span>}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <p className="text-capitalize">{data?.subdomain_type}</p>
                                                    </td>                                                    
                                                    <td className="subdomain-ip-container">                                                        
                                                        {data?.ip_addresses.length > 0 ?
                                                            data?.ip_addresses.map((ipAddress, index)=>{
                                                                if(index <= 2) {
                                                                    return (
                                                                        <div className={`ip-section d-flex mb-2 ${data?.ip_addresses?.length > 1 ? "border-bottom" : ""}`} key={index}>
                                                                            <div className="ip-address">
                                                                                {ipAddress?.ip_address}
                                                                            </div>
                                                                            <div className="ports-container">
                                                                                {ipAddress?.ports.length > 0 && 
                                                                                ipAddress?.ports.map((data, index)=>{
                                                                                    return (
                                                                                        <div className="d-inline-block mx-1 mb-2" key={index}>
                                                                                            {ipAddress?.risky_port && <p className="status-open">{data?.port}</p>}
                                                                                            {!ipAddress?.risky_port && <p className="status-close">{data?.port}</p>}
                                                                                        </div>
                                                                                    )
                                                                                })}
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }
                                                                return null
                                                            })
                                                            :
                                                            "-"
                                                        }
                                                        {
                                                            data?.ip_addresses?.length > 3 && <p className="cursor-pointer view-all mb-4" onClick={()=>{
                                                                setIpAddressList(data)
                                                                setShowIpAddressListModal(true)
                                                            }}>{`+${data?.ip_addresses?.length - 3}`} view all</p>
                                                        }
                                                    </td>
                                                    <td>
                                                        {
                                                            data?.technologies?.length > 0 ?
                                                            data?.technologies.map((data, index)=>{
                                                                if(index <= 1) {
                                                                    return (
                                                                        <span key={index}>{data?.name}, </span>
                                                                    )
                                                                }
                                                                return null
                                                            })
                                                            :
                                                            "-"
                                                        }
                                                        {
                                                            data?.technologies?.length > 2 && <p className="cursor-pointer view-all" onClick={()=>{
                                                                setSeletectedtechnologiesList(data)
                                                                setShowTechnologyListModal(true)
                                                            }}>{`+${data?.technologies?.length - 2}`} view all</p>
                                                        }
                                                    </td>
                                                    {/* <td className="status-container">
                                                        {
                                                            data?.ssl_certificates.length > 0 ?
                                                            getSSLExpiredStatus(data) ? <div className="status-open">
                                                            Expired {
                                                                <CustomTooltip content={getSSLExpiredPort(data)} type="subdomainIpAddress">
                                                                {cerInfoIcon()}
                                                                </CustomTooltip>
                                                            }</div> : <p className="status-close">Not Expired</p> : "-"
                                                        }                                                        
                                                    </td> */}
                                                    <td className="status-container">
                                                        {data?.subdomain_takeover?.is_vulnerable ? 
                                                            <div className="status-open">
                                                                Yes <CustomTooltip content={data?.subdomain_takeover?.name} type="default">
                                                                {cerInfoIcon()}
                                                                </CustomTooltip>
                                                            </div> 
                                                            : <p className="status-close">No</p>}
                                                    </td>
                                                </motion.tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>
                        }
                        
                        { !isLoading && subDomainList && !scanNotFound && subDomainList?.results?.length > 0 &&
                            <Pagination
                                className="pagination-bar"
                                currentPage={currentPage}
                                pageSize={currentPageSize}
                                totalCount={subDomainList?.meta?.total_results}
                                onPageChange={setCurrentPageandRecordSize}
                            />
                        }
                        {
                            !isLoading && !scanNotFound && subDomainList !== "" && subDomainList?.results?.length === 0 && 
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4 }}
                            >
                                <NoDataFound noDataText={"No Record Found"}/>
                            </motion.div>
                        }
                        {
                            !isLoading && scanNotFound && 
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4 }}
                            >
                                <NoDataFound noDataText={subDomainList?.description} />
                            </motion.div>
                        }
                    </div>
                </div>
                <Modal
                    show={showViewAllModal}
                    onHide={()=>setShowViewAllModal(false)}
                    size="md"
                    centered
                    className=""
                    >
                        <Modal.Body>
                            <div className="delete-organization-container">
                                <h4>{selectedViewAll}</h4>
                                <div className="p-2 m-2 type-list-container">
                                    { selectedViewAll === "Subdomain Type" &&
                                        <div className="mt-3">
                                        {
                                            subDomainStats !== "" && subDomainStats?.stats?.subdomain_type?.records && Object.entries(subDomainStats?.stats?.subdomain_type?.records).length > 0 &&
                                            Object.entries(subDomainStats?.stats?.subdomain_type?.records).map(([key, value], index) => {
                                                return (
                                                    <motion.div
                                                        key={index}
                                                        initial={{ opacity: 0, y: 20 }}
                                                        animate={{ opacity: 1, y: 0 }}
                                                        transition={{ duration: 0.4, delay: index * 0.1 }}
                                                    >
                                                        <div className="d-flex align-items-center justify-content-between gap-3 p-3 border-bottom scan-info-type-modal">
                                                            <p className="modal-key">{key}</p>
                                                            <p className="count-type total-count">{formatNumber(value)}</p> 
                                                        </div>
                                                    </motion.div>                                               
                                                )                                         
                                            })
                                        }
                                        </div>
                                    }
                                    { selectedViewAll === "Webserver Type" &&
                                        <div className="mt-3">
                                            {
                                                subDomainStats !== "" && subDomainStats?.stats?.webserver_type?.records && Object.entries(subDomainStats?.stats?.webserver_type?.records).length > 0 &&
                                                Object.entries(subDomainStats?.stats?.webserver_type?.records).map(([key, value], index) => {
                                                    return (
                                                        <motion.div
                                                            key={index}
                                                            initial={{ opacity: 0, y: 20 }}
                                                            animate={{ opacity: 1, y: 0 }}
                                                            transition={{ duration: 0.4, delay: index * 0.1 }}
                                                        >
                                                            <div className="d-flex align-items-center justify-content-between gap-3 p-3 border-bottom scan-info-type-modal">                                                                    
                                                                <ProfileAvatar type="domain" name={key} imageUrl={getWebserverImageUrl(key)} />
                                                                <p className="count-type total-count">{formatNumber(value)}</p>
                                                            </div>
                                                        </motion.div>
                                                    )                                          
                                                })
                                            }
                                        </div>                                    
                                    }
                                </div>
                                <div className="d-flex justify-content-center gap-3 mt-4">
                                    <div className="w-50">
                                        <Button buttonText="Close" buttonType={"secondary"} buttonClicked={()=>setShowViewAllModal(false)}/>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                </Modal>
                <Modal
                    show={showTechnologyListModal}
                    onHide={()=>setShowTechnologyListModal(false)}
                    size="lg"
                    centered
                    className=""
                    >
                        <Modal.Body>
                            <div className="delete-organization-container">
                                <h4>Technology List</h4>
                                <div className="p-2 m-2 type-list-container"> 
                                    <div className="mt-3">
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Version</th>
                                                    <th>Port</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                { 
                                                    seletectedtechnologiesList?.technologies.map((data, index)=>{
                                                        return (
                                                            <motion.tr
                                                                key={index}
                                                                initial={{ opacity: 0, y: 20 }}
                                                                animate={{ opacity: 1, y: 0 }}
                                                                transition={{ duration: 0.4, delay: index * 0.1 }}
                                                            >
                                                                <td>{data?.name!== null ? <ProfileAvatar type="domain" name={data?.name} imageUrl={getProfileImage(data, "profile")} /> : "-"}</td>
                                                                <td>{data?.version !== null ? data?.version : "-"}</td>
                                                                <td>{data?.port !== null ? data?.port : "-"}</td>
                                                            </motion.tr>
                                                        )
                                                    })                                                        
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-center gap-3 mt-4">
                                    <div className="w-25">
                                        <Button buttonText="Close" buttonType={"secondary"} buttonClicked={()=>setShowTechnologyListModal(false)}/>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                </Modal>
                <Modal
                    show={showIpAddressListModal}
                    onHide={()=>setShowIpAddressListModal(false)}
                    size="md"
                    centered
                    className=""
                    >
                        <Modal.Body>
                            <div className="delete-organization-container">
                                <h4 className="mb-3">IP Addresses</h4>
                                <h4 className="mb-3">Total : {ipAddressList?.ip_addresses.length}</h4>
                                <div className="type-list-container"> 
                                    <div className="js-secrets-table">
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th>IP Addresses</th>
                                                    <th>Ports</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                { 
                                                    ipAddressList?.ip_addresses.map((data, index)=>{
                                                        return (
                                                            <motion.tr
                                                                key={index}
                                                                initial={{ opacity: 0, y: 20 }}
                                                                animate={{ opacity: 1, y: 0 }}
                                                                transition={{ duration: 0.4, delay: index * 0.1 }}
                                                            >
                                                                <td>{data?.ip_address}</td>
                                                                <td className="status-container">
                                                                    <div className="ports-container">
                                                                        {data?.ports.length > 0 && 
                                                                        data?.ports.map((data, index)=>{
                                                                            return (
                                                                                <div className="d-inline-block mx-1 mb-2" key={index}>
                                                                                    {data?.risky_port && <p className="status-open">{data?.port}</p>}
                                                                                    {!data?.risky_port && <p className="status-close">{data?.port}</p>}
                                                                                </div>
                                                                            )
                                                                        })}
                                                                    </div>
                                                                </td>
                                                            </motion.tr>
                                                        )
                                                    })                                                        
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-center gap-3 mt-4">
                                    <div className="w-50">
                                        <Button buttonText="Close" buttonType={"secondary"} buttonClicked={()=>setShowIpAddressListModal(false)}/>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                </Modal>               
            </div>
        </>        
    )
}


export default SecurityOverviewSubDomains;